<template>
	<div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/admin/discount-coupons" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Gutscheincodes hinzufügen</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="discountofferForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
            	<div class="col-md-6 form-div">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    rules="required"
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Angebotstyp ist erforderlich',
	                    }"
	                  	>
	                    <v-select
	                      :items="offerType"
	                      v-model="form.offerType"
	                      :error-messages="errors[0]"
	                      item-text="name"
	                      item-value="id"
	                      label="Angebotstyp"
	                      outlined
	                    />
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <div class="col-md-6 form-div">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    rules="required"
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Betrag ist erforderlich',
	                    }"
	                  	>
	                    
	                    <v-text-field
	                      v-model="form.offerValue"
	                      :error-messages="errors[0]"
	                      label="Betrag/Prozentsatz"
	                      outlined
	                    ></v-text-field>
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <div class="col-md-6 form-div">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    rules="required"
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Berechnung ist erforderlich',
	                    }"
	                  	>
	                    <v-select
	                      :items="calculationType"
	                      v-model="form.calculationType"
	                      :error-messages="errors[0]"
	                      item-text="name"
	                      item-value="id"
	                      label="Berechnung"
	                      outlined
	                    />
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <div class="col-md-6 form-div">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    rules="required|priceInput"
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Mindestbetrag ist erforderlich',
	                    }"
	                  	>
	                    <v-text-field
	                      v-model="form.minimumAmount"
	                      :error-messages="errors[0]"
	                      label="Mindestbetrag"
	                      outlined
	                    ></v-text-field>
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <div class="col-md-6 form-div">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    rules="required"
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Gültigkeit bei Händlern ist erforderlich',
	                    }"
	                  	>
	                    <v-select
	                      :items="validFor"
	                      v-model="form.validFor"
	                      :error-messages="errors[0]"
	                      item-text="name"
	                      item-value="id"
	                      label="Gültigkeit bei Händlern"
	                      outlined
	                      @change="codeValidFor()"
	                    />
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <div class="col-md-6 form-div" v-show="form.validFor == 'Bei einem spezifischen Händler gültig'">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Gültigkeit bei Händlern ist erforderlich',
	                    }"
	                  	>
	                    <v-select
	                      :items="providers"
	                      v-model="form.dealer_ids"
	                      :error-messages="errors[0]"
	                      item-text="brand_name"
	                      item-value="user_id"
	                      label="Gültigkeit bei Händlern"
	                      multiple
	                      outlined
	                    />
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <div class="col-md-6 form-div">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    rules="required"
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Bezahlung durch Gustoreich oder Händler ist erforderlich',
	                    }"
	                  	>
	                    <v-select
	                      :items="paymentMethod"
	                      v-model="form.paymentMethod"
	                      :error-messages="errors[0]"
	                      item-text="name"
	                      item-value="id"
	                      label="Bezahlung durch Gustoreich oder Händler"
	                      outlined
	                    />
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <div class="col-md-6 form-div">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    rules="required"
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Gutscheincode ist erforderlich',
	                    }"
	                  	>
	                    <v-text-field
	                      v-model="form.couponCode"
	                      :error-messages="errors[0]"
	                      label="Gutscheincode"
	                      outlined
	                    ></v-text-field>
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <!-- {{date}} -->
	            <div class="col-md-6 form-div">
								<v-menu
									ref="menu"
									v-model="menu"
									:close-on-content-click="false"
									:return-value.sync="date"
									transition="scale-transition"
									offset-y
									max-width="300"
									>
									<template v-slot:activator="{ on, attrs }">
									  <ValidationProvider
									    rules="required"
									    v-slot="{ errors }"
									    :custom-messages="{
									      required: 'Geburtsdatum ist erforderlich.',
									    }"
									  >
									    <v-text-field
									      label="Datum ab"
									      placeholder="TT/MM/JJJJ"
									      :error-messages="errors[0]"
									      outlined
									      v-bind="attrs"
									      v-on="on"
									      v-model="formattedDate"

									      
									    ></v-text-field>
									   
									  </ValidationProvider>
									</template>
									<v-date-picker
									  locale="de-at"
									  :first-day-of-week="1"
									  v-model="date"
									  :min="minDate"
									  no-title
									  scrollable
									  @change="changeDateFormat()"
									>
									  <v-spacer></v-spacer>
									  <v-btn text color="primary" @click="menu = false">
									    ABBRECHEN
									  </v-btn>
									  <v-btn
									    text
									    color="primary"
									    @click="$refs.menu.save(date)"
									  >
									    OK
									  </v-btn>
									</v-date-picker>
								</v-menu>
	                      
              </div>
<!-- {{toDate}} -->
              <div class="col-md-6 form-div">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :return-value.sync="toDate"
                  transition="scale-transition"
                  offset-y
                  max-width="300"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :custom-messages="{
                        required: 'Geburtsdatum ist erforderlich.',
                      }"
                    >
                      <v-text-field
                        label="Datum bis"
                        placeholder="TT/MM/JJJJ"
                        :error-messages="errors[0]"
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        v-model="formattedToDate"
                      ></v-text-field>
                     
                    </ValidationProvider>
                  </template>
                  <v-date-picker
                    locale="de-at"
                    :first-day-of-week="1"
                    v-model="toDate"
                    :min="mintoDate"
                    :max="maxDate"
                    no-title
                    scrollable
                    @change="changetoDateFormat()"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu1 = false">
                      ABBRECHEN
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu1.save(toDate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>

            </div>
            <div class="row">

              <div class="fo-row-btn text-right">
                <v-btn
                  class="submit-btn-fill-outline"
                  @click="goToBack"
                >
                  Abbrechen
                </v-btn>
                <v-btn
                  type="submit"
                  :disabled="isDisabled"
                  ref="kt_form_submit_btn"
                  class="submit-btn-fill-color"
                >
                  {{ submitText }}
                </v-btn>
              </div>
            </div>
        </b-form>
    </ValidationObserver>
</div>
</div>
<notifications group="discount-coupons" position="bottom right" />
</div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";
import adminAPI from "@/api/admin";
import Notifications from "vue-notification";
import axios from "axios";
Vue.use(Notifications);

import { extend } from "vee-validate";

extend("priceInput", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^[0-9.,]+$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

export default{
	name: "AddDiscountCoupons",
	data() {
		return {
			menu: false,
			submitText: "Speichern",
			btnDisable: false,
			providers: [],
			date:"",
			toDate:"",
			menu1: false,
			dealerSelectShow: false,
			formattedDate: "",
			formattedToDate: "",
			minDate: new Date(Date.now())
			.toISOString()
			.substr(0, 10),
			mintoDate: new Date(Date.now())
			.toISOString()
			.substr(0, 10),
			maxDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000 * 3600)
        .toISOString()
  			.substr(0, 10),
			offerType: ["Fixer Betrag", "Prozentsatz"],
			
			calculationType: ["Rabatt vom Bruttowert INKLUSIVE Versandkosten", "Rabatt vom Bruttowert EXKLUSIVE Versandkosten"],
			validFor: ["Bei allen Händlern gültig", "Bei einem spezifischen Händler gültig"],
			paymentMethod: ["Bezahlung durch Gustoreich", "Bezahlung durch Händler"],
			form: {
				offerType: "",
				offerValue: "",
				couponCode: "",
				calculationType: "",
				minimumAmount: "",
				validFor: "",
				paymentMethod: "",
				fromDate: "",
				toDate: "",
				dealer_ids: [],
			},
		}
	},

	
	methods: {
		codeValidFor(){
			 if(this.form.validFor == 'Bei einem spezifischen Händler gültig'){
					this.getActiveProducers();
			 }
			 
		},
		changeDateFormat(){
			this.$refs.menu.save(this.date);
			this.formattedDate = moment(String(this.date)).format("DD/MM/YYYY");
			// console.log(this.date + ' 22');
			var fromDate = this.formattedDate;
			fromDate = fromDate.split("/");
			var minDate = new Date( fromDate[2], fromDate[1] - 1, fromDate[0]);

			this.mintoDate = new Date(minDate.getTime() - new Date().getTimezoneOffset() * 60000)
			        .toISOString()
			        .substr(0, 10)
			       
			const dateFromCheck =new Date(this.date);
			const dateToCheck =new Date(this.form.toDate);

			if (dateFromCheck.getTime() > dateToCheck.getTime()) {
				this.form.fromDate = this.date;  
				this.toDate = "";
				this.formattedToDate="";
				this.form.toDate = "";
			}
		},
    changetoDateFormat(){
    	this.$refs.menu1.save(this.toDate);
      	this.formattedToDate = moment(String(this.toDate)).format("DD/MM/YYYY");
		this.form.toDate = this.toDate;
      	
    },
    goToBack() {
      	this.$router.push({ name: "discount-coupons" });
    },

    onSubmit() {
    	this.$refs.discountofferForm.validate().then((success) => {
        if (success) {
          this.btnDisable = true;
          this.submitText = "Wird gespeichert..";
          let fd = new FormData();
          fd.append("offer_type", this.form.offerType == "Prozentsatz" ? '1' : '0');
          fd.append("offer_value", this.form.offerValue);
          fd.append("discount_on", this.form.calculationType == "Rabatt vom Bruttowert EXKLUSIVE Versandkosten" ? '1' : '0');
          fd.append("minimum_order_amount", this.form.minimumAmount);
          fd.append("code", this.form.couponCode);
          const dealers = [];
          if (this.form.validFor != 'Bei allen Händlern gültig') {
          	for (var i = 0; i < this.form.dealer_ids.length; i++) {
	            dealers.push(this.form.dealer_ids[i]);
	          }
	        	fd.append("dealers", JSON.stringify(dealers));
          }
        	
          fd.append("valid_for", this.form.validFor == 'Bei allen Händlern gültig' ? '1' : '0');
          fd.append("payment_method", this.form.paymentMethod == "Bezahlung durch Gustoreich" ? '1' : '0');
          fd.append("valid_from_date", this.date);
          fd.append("valid_to_date", this.toDate);

          fd.append("status", 1);
          setTimeout(() => {
            adminAPI
              .addDiscountOffer(fd)
              .then((response) => {
                if (response.status == "success") {
                  this.submitText = "Absenden"
                  this.btnDisable = false;
                  this.$notify({
                    group: "discount-coupons",
                    type: "success",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                  setTimeout(() => {
                    this.$router.push({ name: "discount-coupons" });
                  }, 2000);
                } else {
                  this.btnDisable = false;
                  this.submitText = "Speichern";

                  this.$notify({
                    group: "discount-coupons",
                    type: "error",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.submitText = "Speichern";
                this.$notify({
                  group: "discount-coupons",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Speichern";
        }
    		});
  	},

  	getActiveProducers() {
    	axios
      .get("guest/producer-brandName-list")
      .then((response) => {
        var responseJson = response.data;
        if (responseJson.status == "success") {
          this.providers = responseJson.data;
        } else {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: responseJson.msg,
            duration: 3000,
          });
        }
      })
      .catch((err) => {
        this.$notify({
          group: "products",
          type: "error",
          position: "bottom right",
          text: err,
          duration: 3000,
        });
      });
  	},
	},
  	computed: {
	    ...mapGetters(["isAuthenticated"]),
	    isDisabled: function () {
	      return this.btnDisable;
    },
  },
}
</script>